import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Ensures the window scrolls to top whenever the route changes,
// unless the route includes a #hash (in which case the in-page
// section scroll is handled by the Header component).
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
